import { createApiClient, redirectToSso } from '@alascorporation/api-client'
import { ssoConfig } from './sso'
import { useAuthStore } from '../stores/authStore'

const api = createApiClient({
  baseURL: (import.meta.env.VITE_API_URL as string | undefined) ?? '/api',
  getToken: () => localStorage.getItem('token'),
  onUnauthorized: () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('sessionType')
    localStorage.removeItem('group')
    redirectToSso(ssoConfig, window.location.pathname + window.location.search)
  },
  // Catches a mid-session gate (e.g. an admin resets this account's password
  // while it's already logged in elsewhere) — see enforce-must-change-password-gate
  // design.md Decision 4/5. ProtectedRoute redirects once this flips true.
  onMustChangePassword: () => {
    useAuthStore.getState().setMustChangePassword(true)
  },
})

export default api
